/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
from '@thd-olt-component-react/fusion-utils';

import { RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withDynamicBundleAccordion } from '@thd-olt-component-middleware/pip';

import { BundleProductOverviewAccordionTitle as BundleProductOverviewAccordionTitleG1Index0K0Header, BundleSpecificationsAccordionTitle as BundleSpecificationsAccordionTitleG1Index1K0Header }
from '@thd-olt-component-react/product-bundle';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleG1Index2K0Header }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleG1Index3K0Header }
from '@thd-olt-component-react/ratings-and-reviews';

const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
};

const SlotG1Placeholder0K0 = null;

const SlotG1Index0ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "bundleproductoverviewaccordiontitle" */
    '@thd-olt-component-react/product-bundle');
};

export const SlotG1Index0LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-bundle'))
      .BundleProductDetails;
  },
  client: SlotG1Index0ClientK0,
  placeholder: SlotG1Placeholder0K0 || getPlaceholder({ skip: true }),
  name: 'BundleProductDetails',
});

lazySlots.LazyBundleProductDetailsG1 = withLayout(
  SlotG1Index0LoadK0,

  null
  ,
  {
    waitForComponent: SlotG1Index0ClientK0,
    placeholder: SlotG1Placeholder0K0 || getPlaceholder({ skip: true })
  }
);

const SlotG1Placeholder1K0 = null;

const SlotG1Index1ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "bundleproductoverviewaccordiontitle" */
    '@thd-olt-component-react/product-bundle');
};

export const SlotG1Index1LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-bundle'))
      .BundleSpecifications;
  },
  client: SlotG1Index1ClientK0,
  placeholder: SlotG1Placeholder1K0 || getPlaceholder({ skip: true }),
  name: 'BundleSpecifications',
});

lazySlots.LazyBundleSpecificationsG1 = withLayout(
  SlotG1Index1LoadK0,

  null
  ,
  {
    waitForComponent: SlotG1Index1ClientK0,
    placeholder: SlotG1Placeholder1K0 || getPlaceholder({ skip: true })
  }
);

const SlotG1Placeholder2K0 = null;

const SlotG1Index2ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "bundleproductoverviewaccordiontitle" */
    '@thd-olt-component-react/questions-and-answers');
};

export const SlotG1Index2LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
      .QuestionsAndAnswersAccordionBody;
  },
  client: SlotG1Index2ClientK0,
  placeholder: SlotG1Placeholder2K0 || getPlaceholder({ skip: true }),
  name: 'QuestionsAndAnswersAccordionBody',
});

lazySlots.LazyQuestionsAndAnswersAccordionBodyG1 = withLayout(
  SlotG1Index2LoadK0,

  null
  ,
  {
    waitForComponent: SlotG1Index2ClientK0,
    placeholder: SlotG1Placeholder2K0 || getPlaceholder({ skip: true })
  }
);

const SlotG1Placeholder3K0 = null;

const SlotG1Index3ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "bundleproductoverviewaccordiontitle" */
    '@thd-olt-component-react/ratings-and-reviews');
};

export const SlotG1Index3LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
      .RatingsAndReviewsAccordionBody;
  },
  client: SlotG1Index3ClientK0,
  placeholder: SlotG1Placeholder3K0 || getPlaceholder({ skip: true }),
  name: 'RatingsAndReviewsAccordionBody',
});

lazySlots.LazyRatingsAndReviewsAccordionBodyG1 = withLayout(
  SlotG1Index3LoadK0,

  null
  ,
  {
    waitForComponent: SlotG1Index3ClientK0,
    placeholder: SlotG1Placeholder3K0 || getPlaceholder({ skip: true })
  }
);

let RulesMiddleware_MiddlewareSlot_G1 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_G1 = withDynamicBundleAccordion(RulesMiddleware_MiddlewareSlot_G1, { render: [{ name: 'QuestionsAndAnswersAccordionTitle' }, { name: 'RatingsAndReviewsAccordionTitle' }] });

const LazyG1Accordion = withLayoutAccordion([
  [

    [

      withLayout(
        BundleProductOverviewAccordionTitleG1Index0K0Header,

      ),

    ],

    [

      withLayout(
        BundleSpecificationsAccordionTitleG1Index1K0Header,

      ),

    ],

    [

      withLayout(
        QuestionsAndAnswersAccordionTitleG1Index2K0Header,

      ),

    ],

    [

      withLayout(
        RatingsAndReviewsAccordionTitleG1Index3K0Header,

      ),

    ],

  ],
  [

    [

      lazySlots.LazyBundleProductDetailsG1,

    ],

    [

      lazySlots.LazyBundleSpecificationsG1,

    ],

    [

      lazySlots.LazyQuestionsAndAnswersAccordionBodyG1,

    ],

    [

      lazySlots.LazyRatingsAndReviewsAccordionBodyG1,

    ],

  ]
],

RulesMiddleware_MiddlewareSlot_G1
);

// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
  components.forEach((com, index) => {
    // eslint-disable-next-line no-param-reassign
    com.props = hydratedProps[index];
  });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  if (props.slot === 'slotG1') {

    return (
      <LazyG1Accordion
        {...props}
        config={props.config}
        fusionSlotName="slotG1"
        fusionComponentName="accordion"
        fusionClassName={slot.fusionClassName}
        isDynamic
        // commenting inner query provider since withDynamicImport already wraps AccordionBody with inner query provider
        // queryProvider={{
        //   inherit: 'page',
        //   merge,
        //   queryOptions,
        //   cache key for all accordions must be the same
        //   otherwise a race condition will occur generating duplicate requests
        //   cacheKey: 'page',
        //   defaultVariables: props?.qctx?.defaultVariables?.current || { storeId, zipCode: storeZip }
        // }}
      />
    );

  }

  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};
